import { useStatsigClient } from '@statsig/react-bindings'
import { usePathname } from 'next/navigation'
import { useMemo } from 'react'
import { isDesktop } from 'react-device-detect'
/**
 * Hook for exp_330_cap_one_shopping_lbm experiment.
 * This hook determines whether to open the leave behind modal
 * for CapOne Shopping based on the experiment and the current pathname.
 * @returns {boolean} - Whether to remove author or not.
 */
export const useShouldOpenLeaveBehindModalCapOneShopping = () => {
  const statsigClient = useStatsigClient()
  const pathname = usePathname()

  const validPaths = [
    '/credit-cards/tips/pay-0-interest-v1/',
    '/credit-cards/tips/pay-0-interest-bt/',
  ]

  const isValidPath = Boolean(validPaths.includes(pathname))

  const shouldRemoveAuthorTips = useMemo(() => {
    const shouldBeInExperiment = isValidPath && isDesktop

    return shouldBeInExperiment
      ? statsigClient
          .getExperiment('exp_330_cap_one_shopping_lbm')
          .get('should-open-cap-one-shopping-lbm', false)
      : false
  }, [statsigClient, isValidPath])

  return shouldRemoveAuthorTips
}
